import React, { useState, useEffect, useRef } from 'react';
import { PropTypes } from 'prop-types';
import Redactor from '../../../static/redactor';

const RedactorEditor = ({
  text,
  setText,
  id,
}) => {
  const [currentText, setCurrentText] = useState(text);
  const redactorId = id.replace(/-/g, '');

  const setTextRef = useRef(setText);

  // Keep language ref updated
  useEffect(() => {
    setTextRef.current = setText;
  }, [setText]);


  const cleanupRedactor = () => {
    const existingElement = document.querySelector(`#redactor${redactorId}`);
    if (existingElement) {
      const redactorElements = document.querySelectorAll(`[id^="redactor${redactorId}"]`);
      redactorElements.forEach((el) => {
        try {
          if (el && el.id !== `redactor${redactorId}`) {
            if (el.parentNode) el.parentNode.removeChild(el);
          }
        } catch (e) {
          console.log('Cleanup error:', e);
        }
      });
    }
  };

  useEffect(() => {
    setCurrentText(text);
    const element = document.getElementById(`redactor_${redactorId}`);
    if (!element) return;

    // Cleanup before initializing
    cleanupRedactor();

    // Initialize new instance
    const timer = setTimeout(() => {
      try {
        const instance = Redactor(`#redactor_${redactorId}`, {
          callbacks: {
            blur: () => {
              const newTextFromRedactor = instance.source.getCode();
              setTextRef.current(newTextFromRedactor);
            },
          },
        });
        // Set initial content
        instance.source.setCode(text);
      } catch (e) {
        console.log('Redactor initialization error:', e);
      }
    }, 50);

    // eslint-disable-next-line consistent-return
    return () => {
      clearTimeout(timer);
      cleanupRedactor();
    };
  }, [text, id]); // Added id as dependency

  const doNothing = (e) => { setCurrentText(e.target.value); };

  return (
    <textarea
      id={`redactor_${redactorId}`}
      onChange={doNothing}
      value={currentText}
    />
  );
};

RedactorEditor.propTypes = {
  text: PropTypes.string,
  setText: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};

RedactorEditor.defaultProps = {
  text: '',
};

export default RedactorEditor;
